import { baseThunkConfig, createAppSlice } from '@exp/redux/createAppSlice';

import { type Country, getCountries } from '../api/address';

type AddressState = { countries?: Country[] };

/**
 * Address Slice
 */
const addressSlice = createAppSlice({
  initialState: {} as AddressState,
  name: 'address',
  reducers: (create) => ({
    fetchCountries: create.asyncThunk(() => getCountries(), {
      ...baseThunkConfig,
      fulfilled: (state, action) => {
        state.countries = action.payload;
      },
    }),
  }),
  selectors: {
    selectCountries: (state) => state.countries,
  },
});

export const { fetchCountries } = addressSlice.actions;

export const { selectCountries } = addressSlice.selectors;

export default addressSlice;
